'use strict';

const basePickerProperties = {
	items: '<?',
	itemIdField: '@',
	itemsIsPlainArray: '@',
	itemTitleField: '@',
	itemDropdownLabelField: '@',
	loadItems: '<',
	dropdownHtmlClass: '@',
	selectedItems: '=?',
	noLabel: '<?',
	onBlur: '<',
	hideIcon: '<?',
	replaceOnBrowseLookup: '<',
};

const commonPickerProperties = Object.assign(basePickerProperties, {
	loadOnTyping: '@',
	loadDelay: '@',
	navigateItem: '<',
	browseLookup: '<',
	notFound: '<',
	loadMoreConfig: '<',
	itemDetailsField: '@',
});

export { basePickerProperties, commonPickerProperties };
